<div class="flex flex-col md:flex-row w-full">
  <div class="flex menu-header">
      <left-menu [menuItems]="menuItems" [showPoints]="false" class="hidden md:flex"></left-menu>

      <div class="flex md:hidden w-full items-start bg-white justify-between p-5 pt-6">
          <img [src]="assetUrl + 'icons/gloget_logo-trans.png'" class="w-[96px]" alt="Glo logo" />
          <div 
              (click)="openMenuDialog()"
              class="flex flex-end py-1 p-0 md:hidden">
              <img [src]="assetUrl + 'icons/menu.svg'">
          </div>
    </div>
  </div>

  <main class="md:ml-[24vw] flex md:w-[74.5vw] w-full pt-8 px-4 md:p-[0px_10px_0px_60px] justify-center">
    <router-outlet/>
  </main>
</div>